import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DashboardGlobalService {
    projectEditing = false;

    isCommented = false;
}
